import { ESRI } from '../../../esri-loader-util';
import { InputConverterFunc } from '../../../inputConverter';

export interface IBasemapConfig {
    portalItemId?: string;
    tileUrl?: string;
    thumbnailTile?: string;
    tileTemplate?: string;
    title: string;
    copyrightText?: string;
}

export const CreateBasemapsFromConfig = async (basemapConfig: IBasemapConfig) => {
    let Basemap: __esri.BasemapConstructor, PortalItem: __esri.PortalItemConstructor, WebTileLayer: __esri.WebTileLayerConstructor;
    [Basemap, PortalItem, WebTileLayer] = await Promise.all([ESRI.Basemap, ESRI.PortalItem, ESRI.WebTileLayer]);

    const basemap = new Basemap({
        id: basemapConfig.title,
        thumbnailUrl: basemapConfig.tileUrl + basemapConfig.thumbnailTile,
        title: basemapConfig.title
    });

    if (basemapConfig.portalItemId === undefined) {
        basemap.baseLayers.add(
            new WebTileLayer({
                urlTemplate: basemapConfig.tileUrl + basemapConfig.tileTemplate,
                copyright: basemapConfig.copyrightText
            })
        );
    } else {
        basemap.portalItem = new PortalItem({
            id: basemapConfig.portalItemId
        });
    }

    return basemap;
};

export const BasemapConfigurationArrayConverter: InputConverterFunc<IBasemapConfig> = (value: any) => {
    if (typeof value === 'string') {
        return <Array<IBasemapConfig>>JSON.parse(value);
    }
    return value ? value : [];
};

export type BasemapId = 'streets'
    | 'satellite'
    | 'hybrid'
    | 'topo'
    | 'gray'
    | 'dark-gray'
    | 'oceans'
    | 'national-geographic'
    | 'terrain'
    | 'osm'
    | 'dark-gray-vector'
    | 'gray-vector'
    | 'streets-vector'
    | 'topo-vector'
    | 'streets-night-vector'
    | 'streets-relief-vector'
    | 'streets-navigation-vector';
